import { GraphQlClient } from '@intelipost-js/secure-providers';
import '@babel/polyfill';
import { ScToast } from '@intelipost-js/secure-components';

export default {

  async validateApp({ commit }, args) {
    try {
      const body = {
        app_id: args.app_id.toString(),
        app_config: JSON.stringify(args.app_config),
      };

      const { data } = await GraphQlClient.mutation(`
        mutation ($app_id: String!, $app_config: String!) {
          validateApp(app_id: $app_id, app_config: $app_config) {
                ok
                message
              }
          }
        `, body);

      const validateApp = data.validateApp;

      if (validateApp.ok) {
        commit('setAppConfigV2', args.app_config);
      }
      return Promise.resolve(validateApp);
    } catch (e) {
      ScToast.open({
        message: 'Falha ao validar credenciais',
        duration: 20000,
        type: 'is-danger',
      });
      return Promise.reject(e);
    }
  },
};




// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-integrations/features/integrations-app-v2/store/actions.js